// Phase H Wave 3B.3 · V12 Language Toggle (IT / EN).
// Scope: V12AdminLayout topbar · persistenza localStorage.
// V12 Achromatic Strict · italiano puro per label disponibili.
import React from "react";
import { Languages } from "lucide-react";

import { useTranslation } from "@/i18n/I18nContext";

export default function V12LanguageToggle() {
    const { locale, setLocale, availableLocales } = useTranslation();
    const nextLocale = locale === "it" ? "en" : "it";

    return (
        <div
            className="inline-flex items-center rounded-md border border-[#1A1A1A]
                       bg-[#111111] overflow-hidden"
            data-testid="v12-language-toggle"
        >
            <span
                className="hidden sm:inline-flex items-center px-2 text-neutral-500"
                aria-hidden
            >
                <Languages size={12} className="stroke-zinc-500" />
            </span>
            {availableLocales.map((loc) => (
                <button
                    key={loc}
                    type="button"
                    onClick={() => setLocale(loc)}
                    className={`px-2 py-1.5 text-[11px] uppercase tracking-wider
                               transition
                               ${loc === locale
                            ? "bg-[#1A1A1A] text-neutral-100"
                            : "text-neutral-500 hover:text-neutral-200"}`}
                    aria-pressed={loc === locale}
                    data-testid={`v12-language-toggle-${loc}`}
                    title={loc === "it" ? "Italiano" : "English"}
                >
                    {loc}
                </button>
            ))}
            {/* a11y helper · nascosto · comunica il locale corrente */}
            <span className="sr-only" data-testid="v12-language-toggle-current">
                {locale}
            </span>
            <span className="sr-only" data-testid="v12-language-toggle-next">
                {nextLocale}
            </span>
        </div>
    );
}
